import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { AccountListState, AccountListContextActionTypes } from './types';
import { defaultAccountListState } from './defaultState';

const AccountListContext = createContext<Partial<AccountListState>>(defaultAccountListState);
const AccountListDispatchContext = createContext<
  Dispatch<PayloadAction<AccountListContextActionTypes, any>> | undefined
>(undefined);

export { AccountListContext, AccountListDispatchContext };
